import React, { useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { BaseTemplate, PageHead } from '@myob/myob-widgets';
import Form from './components/Form';
import farewell from 'assets/images/farewell.svg';
import { HeadingWrapper, NotificationWrapper } from 'modules/Cancellation/styles';
import { useDispatch } from 'react-redux';
import { getParameterByName } from 'helpers/query';
import { fetchDecryptedData, updateIsFromProduct } from 'modules/Cancellation/reducers';
import { RootState } from 'stores';
import { CancellationState } from 'modules/Cancellation/reducers/type';
import LoadingWrapper from 'components/LoadingWrapper';
import { Notification } from 'components/Notification';
// @ts-ignore
import { auth } from '@my-account/tools';
import NavigationBar from 'components/NavigationBar';
import { BackBreadcrumbs } from 'components/Breadcrumbs';
import { ERoutePath } from 'router';
import { ETelemetryNames } from 'telemetry/type';
import { useRouteMatch } from 'react-router-dom';
import { ENotificationType } from 'stores/reducers/notification/type';

export type Props = {};

export const Cancellation: React.FC<Props> = () => {
    const encryptedId = getParameterByName('id');
    const dispatch = useDispatch();
    useEffect(() => {
        if (encryptedId) {
            dispatch(fetchDecryptedData({ id: encryptedId }));
        }
    }, [dispatch, encryptedId]);
    const { isLoading } = useSelector<RootState, CancellationState>(state => state.cancellation);

    const isLogin = auth.isLoggedIn();
    const isMatchProductCancellation = !!useRouteMatch(ERoutePath.RequestCancellation);
    useEffect(() => {
        dispatch(updateIsFromProduct(isMatchProductCancellation));
        dispatch({ type: ENotificationType.Clear });
    }, [dispatch, isMatchProductCancellation]);

    return (
        <Fragment>
            <NavigationBar />
            <LoadingWrapper isLoading={!isLogin || isLoading}>
                <div data-testid="cancellationPage">
                    <BaseTemplate>
                        {isMatchProductCancellation && (
                            <BackBreadcrumbs
                                backPageName="Back to manage my product"
                                backPathname={ERoutePath.ProductManagement}
                                telemetryEventName={ETelemetryNames.Cancellation}
                                buttonName="MyProduct"
                            />
                        )}
                        <NotificationWrapper>
                            <Notification isAutoDismiss={false} />
                        </NotificationWrapper>

                        <HeadingWrapper>
                            <div className="heading-texture">
                                <PageHead title="Cancellation call back request" />
                                <p>
                                    Please fill out the below form if you wish to cancel your product with MYOB and we
                                    will get back to you within 5 business days to finalise the process.
                                </p>
                            </div>
                            <img src={farewell} alt="cancellation farewell" />
                        </HeadingWrapper>
                        <Form isProductCancellation={isMatchProductCancellation} />
                    </BaseTemplate>
                </div>
            </LoadingWrapper>
        </Fragment>
    );
};

export default Cancellation;
